import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Toaster } from 'react-hot-toast';
import toastTemplate from './toastTemplate';
const service = 'https://dt7j04u1665qi.cloudfront.net/24-7.webp'


function RequestCallback() {
    const {successToast, failureToast, WaitingToast, notify} = toastTemplate

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: ''
    });
    const [ready, setReady] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (!!formData.name && !!formData.email && !!formData.phoneNumber) {
            setReady(true)
        } else {
            setReady(false)
        }

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.email || !formData.phoneNumber) {
            alert('Please fill in all required fields.');
            return;
        }
        
        const waitId = WaitingToast()

        try {
            const response = await axios.post('https://7d4nmtpj4g.execute-api.us-east-1.amazonaws.com/first', formData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.data.statusCode === 200) {
                successToast(waitId)
                await setTimeout(() => {
                    notify("We will contact you shortly", "🫰🏼")
                }, 2000)
                setFormData({
                    name: '',
                    email: '',
                    phoneNumber: '',
                    propertyAddress: '',
                    message: '',
                })
                setReady(false)
            } else {
                failureToast(waitId)
                setTimeout(() => {
                    notify("Please Try Again", "😓")
                }, 2500)
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const createObserver = (ref, setIsVisible) => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.3 }
        );
        return observer
    };

    const observeRef = (ref, observer) => {
        if (ref.current) {
            observer.observe(ref.current);
        }
    };

    const [isVisible, setIsVisible] = useState(false);
    const missionRef = useRef(null);

    useEffect(() => {
        const observer = createObserver(missionRef, setIsVisible);
        observeRef(missionRef, observer);

        if (missionRef.current) {
            observer.observe(missionRef.current);
        }

    }, [missionRef]);
    return (
        <>
            <div>
                <Toaster />
            </div>
            <div ref={missionRef} className='py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24 flex flex-col items-center'>
                <div className='grid grid-cols-1 lg:grid-cols-8 gap-8 items-center w-full'>
                    <div className='lg:col-span-6'>
                        <h1 className={`text-2xl sm:text-3xl md:text-4xl font-light tracking-wider mb-4 py-2 transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}>REQUEST A CALLBACK</h1>
                        <p className={`text-xs sm:text-sm md:text-base leading-relaxed text-gray-700 transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
                            Whether you're contemplating investing in Dubai's real estate or seeking support in property management, simply drop your details below. Our experts will promptly connect with you, offering the necessary support and guidance for your real estate ventures.
                        </p>
                        <div className='py-4 space-y-2 text-xs sm:text-sm text-gray-800'>
                            <div className='flex items-center'>
                                <FontAwesomeIcon icon={faCheck} className='mr-3 text-bluColor flex-shrink-0' />
                                <span>Get consultation in minutes</span>
                            </div>
                            <div className='flex items-center'>
                                <FontAwesomeIcon icon={faCheck} className='mr-3 text-bluColor flex-shrink-0' />
                                <span>24x7 support from the marketing team</span>
                            </div>
                            <div className='flex items-center'>
                                <FontAwesomeIcon icon={faCheck} className='mr-3 text-bluColor flex-shrink-0' />
                                <span>Exposure to the right properties and communities</span>
                            </div>
                        </div>
                        <div className="mt-4">
                            <form className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" onSubmit={handleSubmit}>
                                <div>
                                    <input
                                        type="text"
                                        id="name"
                                        placeholder='Name'
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        className="w-full p-3 border border-gray-300 rounded-md text-xs sm:text-sm focus:outline-none"
                                        required
                                    />
                                </div>
                                <div>
                                    <input
                                        type="email"
                                        placeholder='Email'
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="w-full p-3 border border-gray-300 rounded-md text-xs sm:text-sm focus:outline-none"
                                        required
                                    />
                                </div>
                                <div>
                                    <input
                                        type="tel"
                                        placeholder='Mobile number'
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleChange}
                                        className="w-full p-3 border border-gray-300 rounded-md text-xs sm:text-sm focus:outline-none"
                                        required
                                    />
                                </div>
                                <div>
                                    <button type="submit" className={`w-full py-3.5 px-4 bg-black tracking-widest text-white text-xs font-semibold rounded-md hover:bg-gray-800 transition-colors ${ready ? '' : `bg-gray-600 cursor-no-drop`}`}>
                                        SUBMIT
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className='text-xs text-gray-500 mt-3'>
                            <p>By submitting the form, you agree to our <Link to='/TermsAndConditions' className='text-bluColor underline'>Terms & Conditions</Link> and <Link to='/PrivacyPolicy' className='text-bluColor underline'>Privacy Policy.</Link></p>
                        </div>
                    </div>
                    <img className={`lg:col-span-2 rounded-lg shadow-sm object-cover max-w-[220px] mx-auto transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} src={service} loading="lazy" alt="24/7 service" />
                </div>
            </div>
        </>
    )
}

export default RequestCallback